import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const OnyxAITooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    PopperProps={{
      disablePortal: false,
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            boundary: 'window'
          }
        },
        {
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }
      ],
      style: { zIndex: 10002 },
      ...props.PopperProps
    }}
  />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    display: 'flex',
    padding: `${theme.spacing.md}px`,
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '244px',
    gap: `${theme.spacing.xSmall}px`,
    borderRadius: theme.attributes.borderRadius.tertiary,
    background: theme.colors.tooltipBg,
    boxShadow: theme.attributes.boxShadow.navigation
  },
  [`html[data-theme='light'] & .${tooltipClasses.tooltip} .MuiTypography-root`]: {
    color: theme.colors.menuItemText
  }
})
